
import { PlacesProvider, MapProvider } from './context'
import { HomeScreen } from './screens';

const MapsApp = () => {
  return (
    <PlacesProvider>
      <MapProvider>

        <HomeScreen />
      </MapProvider>
    </PlacesProvider>
  )
}

export default MapsApp